import axios from "axios";

const url = process.env.NEXT_PUBLIC_API_URI ?? "http://localhost:8000";
export const API_KEY = process.env.NEXT_PUBLIC_API_KEY ?? "default-api-key";

const axiosInstance = axios.create({
  baseURL: url + "/api/v1",
  withCredentials: true,
  timeout: 300000 * 4, // 20 minutes
  // signal: AbortSignal.timeout(300000 * 4), // 20 minutes
  headers: {
    Accept: "application/json",
    "x-api-key": API_KEY,
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => Promise.reject(error),
);

// Surface the backend's { message } so components can show the real error
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const message =
      error?.response?.data?.message ??
      (error?.response
        ? `Request failed (${error.response.status})`
        : "Network error — is the server running?");
    const normalized: any = new Error(message);
    normalized.status = error?.response?.status;
    return Promise.reject(normalized);
  },
);

export const postData = (domain: string, data?: any) => {
  return axiosInstance.post(`/${domain}`, data, {
    headers: {
      Accept: "application/json",
    },
  });
};

export const postDataImg = (domain: string, data: any) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      data[key].forEach((item: any) => {
        formData.append(key, item);
      });
    } else {
      formData.append(key, data[key]);
    }
  });

  return axiosInstance.post(`/${domain}`, formData, {
    headers: {
      Accept: "application/json",
    },
  });
};

export const getData = (domain: string, data: any = {}) => {
  return axiosInstance.get(`/${domain}`, {
    params: data,
  });
};

export const deleteData = (domain: string) => {
  return axiosInstance.delete(`/${domain}`, {
    headers: {
      Accept: "application/json",
    },
  });
};

export const updateData = (domain: string, data: any) => {
  return axiosInstance.put(`/${domain}`, data, {
    headers: {
      Accept: "application/json",
    },
  });
};

export const patchData = (domain: string, data: any) => {
  return axiosInstance.patch(`/${domain}`, data, {
    headers: {
      Accept: "application/json",
    },
  });
};

/** Upload one or more image files (multipart) — axios sets the boundary itself. */
export const uploadFiles = (files: File[]) => {
  const form = new FormData();
  files.forEach((f) => form.append("files", f));
  return axiosInstance.post(`/upload`, form);
};

export const updateDataImg = (domain: string, data: any) => {
  const formData = new FormData();

  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      data[key].forEach((item: any) => {
        formData.append(key, item);
      });
    } else {
      formData.append(key, data[key]);
    }
  });

  return axiosInstance.put(`/${domain}`, formData, {
    headers: {
      Accept: "application/json",
    },
  });
};
